import { makeStyles, Theme } from '@material-ui/core'

const buildStyles = makeStyles((theme: Theme) => ({
  '@keyframes fadeIn': {
    '0%': {
      opacity: 0,
    },
    '100%': {
      opacity: 1,
    },
  },
  container: {
    position: 'absolute',
    display: 'flex',
    height: '100%',
    width: '100%',
    opacity: 0,
    animation: '$fadeIn 0.5s',
    'animation-fill-mode': 'forwards',
  },
}))

export default buildStyles
